"use client";
import { useTranslations } from 'next-intl';
import style from './filters.module.scss';
import FilterCheckboxGroup from './partials/filter-checkbox-group/FilterCheckboxGroup';
import { useMemo, useState } from 'react';
import FilterBasicGroup from './partials/filter-basic-group/FilterBasicGroup';
import { useFilters } from '@/projectRoot/src/contexts/FiltersContext';
import Button from '@/projectRoot/src/components/common/form-elements/button/Button';
import { Colors } from '@/projectRoot/src/utils/models/globalTypes';
import MultiRangeSlider from './partials/multi-range-slider/MultiRangeSlider';

export enum FilterGroups {
    SIZES = 'stock_variants',
    CATEGORY_ANCESTORS = 'category_ancestor_ids',
    CATEGORIES = 'category_ids',
    BRANDS = 'brand_ids',
    COLLECTIONS = 'collection_ids',
    LABELS = 'label_ids',
    COLORS = 'color_ids',
    GUIDES = 'guides',
    SEGMENT = 'store_only',
    PRICES = 'prices'
}

export interface CheckboxItem {
    id: string;
    title: string;
    icon?: {
        hex: string,
        url?: string
    };
    children?: CheckboxItem[];
}

interface Props {
    onCloseFilters: () => void;
}

const Filters = ({onCloseFilters}: Props) => {
    const t = useTranslations();
    const [opened, setOpened] = useState<string>('');
    const {filters, filters_count, productsCount, dispatch} = useFilters();

    const toggleOpening = (index: string): void => {
        setOpened(opened == index ? '' : index);
    }

  return (
    <aside className={style.filters}>
        {
            filters.options && filters.options.prices
            ?
            <MultiRangeSlider 
                opened={opened == FilterGroups.PRICES} 
                openGroup={() => toggleOpening(FilterGroups.PRICES)}
                classes={[style.filterGroup]}
            />
            : <></>
        }
        {
            filters.options && filters.options.categories && filters.options.categories.length > 0
            ?
            <FilterBasicGroup 
                items={filters.options.categories}
                name={FilterGroups.CATEGORIES}
                title={t('categories')}
                display='text'
                opened={opened == FilterGroups.CATEGORIES}
                openGroup={() => toggleOpening(FilterGroups.CATEGORIES)}
                classes={[style.filterGroup]}
            />
            // <FilterRadioGroup 
            //     items={filters.options.categories ?? []}
            //     name={FilterGroups.CATEGORIES}
            //     title={t('categories')}
            //     opened={opened == FilterGroups.CATEGORIES}
            //     openGroup={() => toggleOpening(FilterGroups.CATEGORIES)}
            //     radioName='categories'
            //     classes={[style.filterGroup]}
            // />
            : <></>
        }
        {
            filters.options && filters.options.colors && filters.options.colors.length > 0
            ?
            <FilterCheckboxGroup 
                items={filters.options.colors.map(color => {return {id: color.id, title: color.title, icon: {hex: color.hex ?? undefined, url: color.image_icon_url ?? undefined}}})}
                name={FilterGroups.COLORS}
                title={t('colors')}
                opened={opened == FilterGroups.COLORS}
                openGroup={() => toggleOpening(FilterGroups.COLORS)}
                classes={[style.filterGroup]}
            />
            : <></>
        }
        {
            filters.options && filters.options.labels && filters.options.labels.length > 0
            ?
            <FilterCheckboxGroup 
                items={filters.options.labels}
                name={FilterGroups.LABELS}
                title={t('labels')}
                opened={opened == FilterGroups.LABELS}
                openGroup={() => toggleOpening(FilterGroups.LABELS)}
                classes={[style.filterGroup]}
            />
            : <></>
        }
        {
            filters.options && filters.options.sizes && filters.options.sizes.length > 0
            ?
            <FilterBasicGroup 
                items={filters.options.sizes.map(size => {return {id: size.value, title: size.value}})}
                name={FilterGroups.SIZES}
                title={t('sizes')}
                display='box'
                opened={opened == FilterGroups.SIZES}
                openGroup={() => toggleOpening(FilterGroups.SIZES)}
                classes={[style.filterGroup]}
            />
            : <></>
        }
        <div className={style.actions}>
            <Button 
                label={t('show_results') + (productsCount > 0 ? ` (${productsCount})` : '')}
                classes={[style.showResults]}
                onClick={() => onCloseFilters()}
                backgroundColor={Colors.DARK}
            />
            {
                filters_count > 0
                ?
                <Button 
                    label={t('reset_all')}
                    classes={[style.resetBtn]}
                    onClick={() => dispatch({type: 'resetFilters'})}
                    backgroundColor={Colors.TRANSPARENT}
                />
                : <></>
            }
        </div>
    </aside>
  ) 
};

export default Filters;
